import React from "react";
import { useTranslation } from "react-i18next";
import img1 from '../../assets/new images/feature1.png';
import img2 from '../../assets/new images/feature2.png';
import img3 from '../../assets/new images/feature3.png';
import img4 from '../../assets/new images/feature4.png';
import img5 from '../../assets/new images/feature5.png';

const Features = () => {
  const { t } = useTranslation();
  // NOTE: pre-existing duplicate content — items 4/5 repeat items 2/3 (same title/desc, different icons). Preserved as-is, no scope creep.
  const features = [
    {
      title: t("whyCabil.personalised"),
      desc: t("whyCabil.personalisedDesc"),
      icon: img1,
    },
    {
      title: t("whyCabil.aiInsights"),
      desc: t("whyCabil.aiInsightsDesc"),
      icon: img2,
    },
    {
      title: t("whyCabil.global"),
      desc: t("whyCabil.globalDesc"),
      icon: img3,
    },
    {
      title: t("whyCabil.aiInsights"),
      desc: t("whyCabil.aiInsightsDesc"),
      icon: img4,
    },
    {
      title: t("whyCabil.global"),
      desc: t("whyCabil.globalDesc"),
      icon: img5,
    },
  ];
  return (
  <section className="py-20 bg-gray-50 text-center">
    <h2 className="text-5xl font-bold text-gray-800 mb-8">{t("features.title")}</h2>
    <p className="max-w-2xl mx-auto text-center text-gray-600 mb-12">

    </p>
    <div className="flex flex-wrap  justify-center gap-10  mx-auto">
      {features.map((f, i) => (
        <div key={i} className="bg-white flex mx-3 md:w-1/4 flex-col gap-2 justify-center items-center p-8 shadow rounded-xl">
          <div className="bg-[#EE5F2B1A]/10 p-4 rounded-xl mb-4">

          <img src={f.icon} alt="" className="w-8  h-8"/>
          </div>
          <h3 className="font-semibold text-xl mb-2">{f.title}</h3>
          <p className="text-gray-600 ">{f.desc}</p>
        </div>
      ))}
    </div>
  </section>
  );
};

export default Features;
